import room_1 from './1-room.png'
import room_2 from './2-rooms.png'
import room_3 from './3-rooms.png'
import room_4 from './4-rooms.png'
import room_s from './studio.png'
import room_1_plan from './1-room-plan.png'
import room_2_plan from './2-rooms-plan.png'
import room_3_plan from './3-rooms-plan.png'
import room_4_plan from './4-rooms-plan.png'
import room_s_plan from './studio-plan.png'
import room_1_photo_1 from './1-room-photo-1.jpg'
import room_1_photo_2 from './1-room-photo-2.jpg'
import room_1_photo_3 from './1-room-photo-3.jpg'
import room_1_photo_4 from './1-room-photo-4.jpg'
import room_1_photo_5 from './1-room-photo-5.jpg'
import room_1_photo_6 from './1-room-photo-6.jpg'
import room_1_photo_7 from './1-room-photo-7.jpg'
import room_2_photo_1 from './2-room-photo-1.jpg'
import room_2_photo_2 from './2-room-photo-2.jpg'
import room_2_photo_3 from './2-room-photo-3.jpg'
import room_2_photo_4 from './2-room-photo-4.jpg'
import room_2_photo_5 from './2-room-photo-5.jpg'
import room_2_photo_6 from './2-room-photo-6.jpg'
import room_2_photo_7 from './2-room-photo-7.jpg'
import room_3_photo_1 from './3-room-photo-1.jpg'
import room_3_photo_2 from './3-room-photo-2.jpg'
import room_3_photo_3 from './3-room-photo-3.jpg'
import room_3_photo_4 from './3-room-photo-4.jpg'
import room_3_photo_5 from './3-room-photo-5.jpg'
import room_3_photo_6 from './3-room-photo-6.jpg'
import room_3_photo_7 from './3-room-photo-7.jpg'
import room_3_photo_8 from './3-room-photo-8.jpg'
import room_3_photo_9 from './3-room-photo-9.jpg'
import room_3_photo_10 from './3-room-photo-10.jpg'
import room_4_photo_1 from './4-room-photo-1.jpg'
import room_4_photo_2 from './4-room-photo-2.jpg'
import room_4_photo_3 from './4-room-photo-3.jpg'
import room_4_photo_4 from './4-room-photo-4.jpg'
import room_4_photo_5 from './4-room-photo-5.jpg'
import room_4_photo_6 from './4-room-photo-6.jpg'
import room_4_photo_7 from './4-room-photo-7.jpg'
import room_4_photo_8 from './4-room-photo-8.jpg'
import room_4_photo_9 from './4-room-photo-9.jpg'
import room_s_photo_1 from './s-room-photo-1.jpg'
import room_s_photo_2 from './s-room-photo-2.jpg'
import room_s_photo_3 from './s-room-photo-3.jpg'
import room_s_photo_4 from './s-room-photo-4.jpg'

const arrOfImg1: string[] = [room_1_photo_1, room_1_photo_2, room_1_photo_3, room_1_photo_4, room_1_photo_5, room_1_photo_6, room_1_photo_7];
const arrOfImg2: string[] = [room_2_photo_1, room_2_photo_2, room_2_photo_3, room_2_photo_4, room_2_photo_5, room_2_photo_6, room_2_photo_7];
const arrOfImg3: string[] = [room_3_photo_1, room_3_photo_2, room_3_photo_3, room_3_photo_4, room_3_photo_5, room_3_photo_6, room_3_photo_7, room_3_photo_8, room_3_photo_9, room_3_photo_10];
const arrOfImg4: string[] = [room_4_photo_1, room_4_photo_2, room_4_photo_3, room_4_photo_4, room_4_photo_5, room_4_photo_6, room_4_photo_7, room_4_photo_8, room_4_photo_9];
const arrOfImgS: string[] = [room_s_photo_1, room_s_photo_2, room_s_photo_3, room_s_photo_4];


export {room_1, room_2, room_3, room_4, room_s, 
    room_1_plan, room_2_plan, room_3_plan, room_4_plan, room_s_plan, 
    arrOfImg1, arrOfImg2, arrOfImg3, arrOfImg4, arrOfImgS
}